<template>
  <div>
    <Card v-if="item.bizSetupJsonStr.netApply">
      <div slot="title" class="tb-row-scatter h-24-px">
        <div class="tb-row-center f-16 c-gray-dark">{{item.name}}&nbsp;&nbsp;&nbsp;
          <Badge v-if="item.depositPaid" text="质保"></Badge>
        </div>
        <div class="tb-row-center">
          <Icon type="ios-checkmark-circle" class="c-cyanine" size="22" v-show="selected && item.id === selected.id"/>
          <Icon type="ios-radio-button-off" size="22" v-show="(!selected || item.id !== selected.id) && item.bizSetupJsonStr && item.bizSetupJsonStr.netApply"/>
          <Icon type="ios-help-circle-outline" size="22" v-show="(!selected || item.id !== selected.id) && (!item.bizSetupJsonStr || !item.bizSetupJsonStr.netApply)"/>
        </div>
      </div>
      <div class="tb-row p-t-10">
        <div class="ti-g-1">
          <img :src="item.showPhotoMainOss|img_oss" v-if="item.showPhotoMainOss" width="80" height="80">
          <img src="img/defaultLogo.png" width="80" height="80" v-else>
        </div>
        <div class="ti-g-4 tb-column m-l-10">
          <div class="ti-20px ti_line-height-20px">电话：{{item.phone}}</div>
          <div class="ti-40px ti_line-height-20px">地址：{{item.address}}</div>
<!--          <div class="ti-20px tb-row">-->
<!--            <img v-if="item.showPoiTagsJson != null && item.bizSetupJsonStr != null" src="img/sealChip.png"-->
<!--                 style="width:18px;height:18px"/>-->
<!--            <div v-if="item.showPoiTagsJson != null && item.bizSetupJsonStr != null"-->
<!--                 class="tb-column-center m-l-5 m-r-12">公安部三所芯片-->
<!--            </div>-->
<!--             <img v-if="item.bizSetupJsonStr != null" src="img/creditScore.png" style="width:18px;height:18px">-->
<!--            <Poptip trigger="hover" title="信用积分规则" :word-wrap="true"-->
<!--                    content="①所有的网上刻章店成交按每枚章信用积分加1分计算。②退单不扣分。③逃单扣10分。④质量问题扣10分。⑤普通投诉扣2分⑥延期交付印章扣2分">-->
<!--              <div v-if="item.bizSetupJsonStr != null" class="tb-column-center m-l-5">信用积分 {{item.bizPoint}}</div>-->
<!--            </Poptip>-->
<!--            <div v-if="item.bizSetupJsonStr == null" class="tb-column-center m-l-5">本企业未开通网上服务</div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="tb-row p-t-10 c-red">
        {{item.depositPaid?'如有质量问题，平台提供先行赔付，最高可获赔5000元':'&nbsp;'}}
      </div>
    </Card>

  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    props: ['item','selected'],
    data() {
      return {}
    },
    computed: {
      ...mapState({
      })
    },
    methods: {
    },
    created() {
    }
  }
</script>
